import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      fontSize: 30,
      fontWeight: 250,
      backgroundColor: theme.accounts.item.empty.default,
      width: 50,
      height: 50,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    icon: {
      marginTop: -4,
      marginLeft: 1,
    },
  };

  return styles;
};
